import { defineComponent } from 'vue';

import { Grid } from 'gridjs';
import 'gridjs/dist/theme/mermaid.css';

export default defineComponent({
  name: 'GridComponent',
  delimiters: ['${', '}'],
  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    data: {
      type: Array,
      default: () => ([]),
    },
    sort: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Object,
      default: () => ({}),
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      grid: null,
    };
  },
  mounted() {
    this.grid = new Grid();
    const {
      columns, data, search, sort, pagination,
    } = this;
    this.grid
      .updateConfig({
        columns,
        data,
        sort,
        search,
        pagination,
      })
      .render(this.$el);
  },
  methods: {
    /**
     * Called by a parent component to update the params and rerender
     * the table rows (used for fetching content)
     */
    updateGridComponent(params: any): void {
      this.grid
        .updateConfig(params)
        .forceRender();
    },
  },
  template: '#t-grid-component',
});
